import { render, staticRenderFns } from "./MarketplaceGummies.vue?vue&type=template&id=53f85d2a&lang=pug&"
import script from "./MarketplaceGummies.vue?vue&type=script&lang=js&"
export * from "./MarketplaceGummies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports